export enum FeatureFlag {
    ASSET_LIBRARY_V2 = 'ASSET_LIBRARY_V2',
    CUSTOM_MERGE_FIELDS = 'CUSTOM_MERGE_FIELDS',
    DASHBOARD_V2 = 'DASHBOARD_V2',
    DISABLE_TEMPLATE_GALLERY_V2_USER_OVERRIDE = 'DISABLE_TEMPLATE_GALLERY_V2_USER_OVERRIDE',
    ENABLE_CROP_RESIZE_ASSET_LIBRARY_V2 = 'ENABLE_CROP_RESIZE_ASSET_LIBRARY_V2',
    ENABLE_DROPPED_GLOBAL_UNSUBSCRIBES_WORKAROUND = 'ENABLE_DROPPED_GLOBAL_UNSUBSCRIBES_WORKAROUND',
    ENABLE_DROPPED_UNSUBSCRIBES_WORKAROUND = 'ENABLE_DROPPED_UNSUBSCRIBES_WORKAROUND',
    ENABLE_EMAIL_PREVIEW_APPROVAL_BYPASS = 'ENABLE_EMAIL_PREVIEW_APPROVAL_BYPASS',
    ENABLE_EMAIL_SUBJECT_MERGE_TAGS = 'ENABLE_EMAIL_SUBJECT_MERGE_TAGS',
    ENABLE_EMAIL_TEMPLATE_DIVIDER = 'ENABLE_EMAIL_TEMPLATE_DIVIDER',
    ENABLE_EMAIL_TEMPLATE_IMAGE_ALT_TEXT = 'ENABLE_EMAIL_TEMPLATE_IMAGE_ALT_TEXT',
    ENABLE_EMAIL_TEMPLATE_MEDIA_TEMPLATE = 'ENABLE_EMAIL_TEMPLATE_MEDIA_TEMPLATE',
    ENABLE_EMAIL_TEMPLATE_PLACEHOLDER = 'ENABLE_EMAIL_TEMPLATE_PLACEHOLDER',
    ENABLE_EMAIL_TEMPLATE_SPACER = 'ENABLE_EMAIL_TEMPLATE_SPACER',
    ENABLE_EMAIL_TEMPLATE_THUMBNAILS = 'ENABLE_EMAIL_TEMPLATE_THUMBNAILS',
    ENABLE_LEFT_HAND_NAVIGATION = 'ENABLE_LEFT_HAND_NAVIGATION',
    ENABLE_LEGACY_TEMPLATE_VERSIONS_LINK = 'ENABLE_LEGACY_TEMPLATE_VERSIONS_LINK',
    ENABLE_LOCATION_DETAILS_V2 = 'ENABLE_LOCATION_DETAILS_V2',
    ENABLE_MAILOPS = 'ENABLE_MAILOPS',
    ENABLE_MOBILE_NAVIGATION = 'ENABLE_MOBILE_NAVIGATION',
    ENABLE_NEW_ASSET_LIBRARY = 'ENABLE_NEW_ASSET_LIBRARY',
    ENABLE_NEW_CONNECT_PAGE = 'ENABLE_NEW_CONNECT_PAGE',
    ENABLE_NEW_GALLERY_PAGE = 'ENABLE_NEW_GALLERY_PAGE',
    ENABLE_NEW_SCHEDULED_PAGE = 'ENABLE_NEW_SCHEDULED_PAGE',
    ENABLE_PUBLISHING_GLOFOX = 'ENABLE_PUBLISHING_GLOFOX',
    ENABLE_PUBLISHING_KITE = 'ENABLE_PUBLISHING_KITE',
    ENABLE_PUBLISHING_MARIANA_TEK = 'ENABLE_PUBLISHING_MARIANA_TEK',
    ENABLE_PUBLISHING_MINDBODY = 'ENABLE_PUBLISHING_MINDBODY',
    ENABLE_PUBLISHING_ZENOTI = 'ENABLE_PUBLISHING_ZENOTI',
    ENABLE_SCHEDULED_PAGE_DOWNLOADS = 'ENABLE_SCHEDULED_PAGE_DOWNLOADS',
    ENABLE_TEMPLATE_GALLERY_DIMENSIONS_FILTER = 'ENABLE_TEMPLATE_GALLERY_DIMENSIONS_FILTER',
    ENABLE_V2_MEDIA_TEMPLATE_QR_LAYER = 'ENABLE_V2_MEDIA_TEMPLATE_QR_LAYER',
    HIDE_V1_EMAIL_PUBLISHING = 'HIDE_V1_EMAIL_PUBLISHING',
    HIDE_V1_MEDIA_TEMPLATE_IMAGES_IN_GALLERY = 'HIDE_V1_MEDIA_TEMPLATE_IMAGES_IN_GALLERY',
    HIDE_V1_MEDIA_TEMPLATE_PRINTS_IN_GALLERY = 'HIDE_V1_MEDIA_TEMPLATE_PRINTS_IN_GALLERY',
    HIDE_V1_MEDIA_TEMPLATE_VIDEOS_IN_GALLERY = 'HIDE_V1_MEDIA_TEMPLATE_VIDEOS_IN_GALLERY',
    INTEGRATION_CONNECTION_HEALTH_NOTIFICATIONS = 'INTEGRATION_CONNECTION_HEALTH_NOTIFICATIONS',
    PERMIT_DOWNLOAD_EMAIL_PUBLISH = 'PERMIT_DOWNLOAD_EMAIL_PUBLISH',
    SHOW_BUILDABLE_AND_BUILDER_TEMPLATES = 'SHOW_BUILDABLE_AND_BUILDER_TEMPLATES',
    SHOW_OLD_EMAIL_TEMPLATES_OPTION = 'SHOW_OLD_EMAIL_TEMPLATES_OPTION',
    SHOW_V2_MEDIA_TEMPLATE_EMAIL_BANNERS_IN_GALLERY = 'SHOW_V2_MEDIA_TEMPLATE_EMAIL_BANNERS_IN_GALLERY',
    SHOW_V2_MEDIA_TEMPLATE_EMAIL_BANNERS_IN_MANAGE_TEMPLATES = 'SHOW_V2_MEDIA_TEMPLATE_EMAIL_BANNERS_IN_MANAGE_TEMPLATES',
    SHOW_V2_MEDIA_TEMPLATE_PRINTS_IN_GALLERY = 'SHOW_V2_MEDIA_TEMPLATE_PRINTS_IN_GALLERY',
    SHOW_V2_MEDIA_TEMPLATE_PRINTS_IN_MANAGE_TEMPLATES = 'SHOW_V2_MEDIA_TEMPLATE_PRINTS_IN_MANAGE_TEMPLATES',
    SHOW_V2_MEDIA_TEMPLATE_SOCIAL_IMAGES_IN_GALLERY = 'SHOW_V2_MEDIA_TEMPLATE_SOCIAL_IMAGES_IN_GALLERY',
    SHOW_V2_MEDIA_TEMPLATE_SOCIAL_IMAGES_IN_MANAGE_TEMPLATES = 'SHOW_V2_MEDIA_TEMPLATE_SOCIAL_IMAGES_IN_MANAGE_TEMPLATES',
    SHOW_V2_MEDIA_TEMPLATE_SOCIAL_VIDEOS_IN_GALLERY = 'SHOW_V2_MEDIA_TEMPLATE_SOCIAL_VIDEOS_IN_GALLERY',
    SHOW_V2_MEDIA_TEMPLATE_SOCIAL_VIDEOS_IN_MANAGE_TEMPLATES = 'SHOW_V2_MEDIA_TEMPLATE_SOCIAL_VIDEOS_IN_MANAGE_TEMPLATES',
    SOCIAL_MERGE_FIELDS = 'SOCIAL_MERGE_FIELDS',
    SOCIAL_MERGE_FIELDS_FRONTEND = 'SOCIAL_MERGE_FIELDS_FRONTEND',
    SOCIAL_REPORTING_TEMPLATES = 'SOCIAL_REPORTING_TEMPLATES',
    TEMPLATE_BUILDER_V2 = 'TEMPLATE_BUILDER_V2',
    TEMPLATE_GALLERY_V2 = 'TEMPLATE_GALLERY_V2',
}
